module.exports = __webpack_public_path__ + "media/images/bootcamp_bckg_2-2f650b4cf4b751c7e2fc7cdc8f0f6c99.png";